import { render, staticRenderFns } from "./DetailProductTower.vue?vue&type=template&id=a186d420&"
import script from "./DetailProductTower.vue?vue&type=script&lang=js&"
export * from "./DetailProductTower.vue?vue&type=script&lang=js&"
import style0 from "./DetailProductTower.vue?vue&type=style&index=0&id=a186d420&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports